import { StrictMode } from 'react'

import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { AuthProvider } from '@enechain/auth-js'
// chakra v3: ecloud の `Provider` (= ChakraProvider value={system} + ColorModeProvider)
// と `Toaster` を root に載せる。`Toaster` は `</Provider>` の直前に置く (= context を
// 見失わないため)。font / 固有 override は `~/constants/system` の system に集約。
import { Provider, Toaster } from '@enechain/ecloud-designsystem'

import { system } from '~/constants/system'
import { initI18n } from '~/i18n'
import { I18nProvider } from '~/i18n/I18nProvider'
import { ApiClientProvider } from '~/providers/ApiClientProvider'
import { DemandForecastLegendProvider } from '~/providers/DemandForecastLegendProvider'
import { ServerClockGate } from '~/providers/ServerClockGate'
import { router } from '~/routes'

// localStorage キャッシュ（前回の表示言語、無ければ 'ja'）で同期 init する。
// 描画前の同期呼び出しが必須のため React コンポーネント外で呼ぶ。
initI18n()

const rootElement = document.getElementById('root')
if (rootElement != null) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <Provider forcedTheme="light" system={system}>
        <AuthProvider
          apiUrl={import.meta.env.VITE_ELOGIN_API_URL}
          loginUrl={import.meta.env.VITE_ELOGIN_URL}
          redirectUri={window.location.origin}
        >
          <ApiClientProvider>
            {/* I18nProvider は ApiClientProvider（Connect transport + QueryClient）の
                内側に置く必要がある。session RPC を TanStack Query 経由で呼ぶため。
                描画をブロックせず、session 取得後に表示言語（メンバーの個人設定、未設定なら組織言語）で i18n を更新する。 */}
            <I18nProvider>
              {/* ページの初期「今日」がブラウザ時計で確定してしまうのを防ぐため、
                  サーバー時刻の offset が確定 (または待ち上限) するまで route の
                  初回描画を遅らせる。理由は ServerClockGate の docstring。 */}
              <ServerClockGate>
                {/* App root に置くことで /demand/forecast-daily のケース間
                    (計画断面が変わる) の別 mount 遷移を跨いで chart 凡例の hiddenKeys を
                    保持する (AC-DFC-009)。ブラウザ再読込は App 自体の再マウントで
                    既定 ON (new Set()) に戻る。 */}
                <DemandForecastLegendProvider>
                  <RouterProvider router={router} />
                </DemandForecastLegendProvider>
              </ServerClockGate>
            </I18nProvider>
          </ApiClientProvider>
        </AuthProvider>
        <Toaster />
      </Provider>
    </StrictMode>,
  )
}
